import "./index.css";
// src/NewProjectSection/NewProjectSection.tsx
import Box4 from "@cloudscape-design/components/box";
import Container from "@cloudscape-design/components/container";
import Header from "@cloudscape-design/components/header";
import Icon2 from "@cloudscape-design/components/icon";
import SpaceBetween5 from "@cloudscape-design/components/space-between";
import * as React2 from "react";
import { useAppTranslation as useAppTranslation4, AppTrans as AppTrans4 } from "@amzn/awsmp-max-translations";

// src/PromptInput/PromptInput.tsx
import PromptInputComponent from "@cloudscape-design/components/prompt-input";
import Box3 from "@cloudscape-design/components/box";
import SpaceBetween4 from "@cloudscape-design/components/space-between";
import Link2 from "@cloudscape-design/components/link";
import FormField from "@cloudscape-design/components/form-field";
import FileInput from "@cloudscape-design/components/file-input";
import FileDropzone, { useFilesDragging } from "@cloudscape-design/components/file-dropzone";
import Icon from "@cloudscape-design/components/icon";
import FileTokenGroup from "@cloudscape-design/components/file-token-group";
import Spinner2 from "@cloudscape-design/components/spinner";
import * as React from "react";
import { ContentBlockVisibility, ACCEPTED_EXTENSIONS_STRING, validateFiles } from "@amzn/awsmp-max-model";
import { useAppTranslation as useAppTranslation3, AppTrans as AppTrans3 } from "@amzn/awsmp-max-translations";

// src/DisclaimerModal/AwsTermsDisclaimerModal.tsx
import Modal from "@cloudscape-design/components/modal";
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import SpaceBetween from "@cloudscape-design/components/space-between";
import TextContent from "@cloudscape-design/components/text-content";
import Link from "@cloudscape-design/components/link";
import { useAppTranslation, AppTrans } from "@amzn/awsmp-max-translations";
import { jsx, jsxs } from "react/jsx-runtime";
var AwsTermsDisclaimerModal = ({ visible, onDismiss }) => {
  const { t } = useAppTranslation();
  return /* @__PURE__ */ jsx(
    Modal,
    {
      size: "medium",
      onDismiss,
      visible,
      header: t("disclaimer"),
      footer: /* @__PURE__ */ jsx(Box, { float: "right", children: /* @__PURE__ */ jsx(Button, { variant: "primary", onClick: onDismiss, children: t("close") }) }),
      "data-testid": "aws-terms-disclaimer-modal",
      children: /* @__PURE__ */ jsx(SpaceBetween, { direction: "vertical", size: "m", children: /* @__PURE__ */ jsx(TextContent, { children: /* @__PURE__ */ jsxs(AppTrans, { i18nKey: "disclaimerModalContent", children: [
        /* @__PURE__ */ jsx(Link, { variant: "primary", external: true, href: "https://aws.amazon.com/terms/" }),
        /* @__PURE__ */ jsx(Link, { variant: "primary", external: true, href: "https://aws.amazon.com/aup/" }),
        /* @__PURE__ */ jsx(Link, { variant: "primary", external: true, href: "https://aws.amazon.com/ai/responsible-ai/policy/" }),
        /* @__PURE__ */ jsx(Link, { variant: "primary", external: true, href: "https://aws.amazon.com/privacy/" }),
        /* @__PURE__ */ jsx(Link, { variant: "primary", external: true, href: "https://aws.amazon.com/terms/" })
      ] }) }) })
    }
  );
};

// src/DisclaimerModal/AiContentDisclaimerModal.tsx
import Modal2 from "@cloudscape-design/components/modal";
import Box2 from "@cloudscape-design/components/box";
import Button2 from "@cloudscape-design/components/button";
import SpaceBetween2 from "@cloudscape-design/components/space-between";
import TextContent2 from "@cloudscape-design/components/text-content";
import { useAppTranslation as useAppTranslation2, AppTrans as AppTrans2 } from "@amzn/awsmp-max-translations";
import { jsx as jsx2 } from "react/jsx-runtime";

// src/PromptInput/PromptInput.module.scss
var PromptInput_module_default = {
  AskAgentModeLabel: "PromptInput_module_AskAgentModeLabel",
  SecondaryContentWrapper: "PromptInput_module_SecondaryContentWrapper",
  FooterContainer: "PromptInput_module_FooterContainer",
  FooterLinksContainer: "PromptInput_module_FooterLinksContainer",
  SecondaryActionsContainer: "PromptInput_module_SecondaryActionsContainer",
  FileInputDisabledWrapper: "PromptInput_module_FileInputDisabledWrapper",
  SecondaryActionsPadding: "PromptInput_module_SecondaryActionsPadding",
  LightGreyText: "PromptInput_module_LightGreyText",
  StatusContainer: "PromptInput_module_StatusContainer",
  StatusText: "PromptInput_module_StatusText",
  StatusTextError: "PromptInput_module_StatusTextError",
  RedesignDropzone: "PromptInput_module_RedesignDropzone"
};

// src/PromptInput/StatusMessage.tsx
import Alert from "@cloudscape-design/components/alert";
import SpaceBetween3 from "@cloudscape-design/components/space-between";
import Spinner from "@cloudscape-design/components/spinner";
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var StatusMessage = ({ type, message, onDismiss }) => {
  if (type === "error") {
    return /* @__PURE__ */ jsx3(Alert, { type: "error", dismissible: !!onDismiss, onDismiss, children: message });
  }
  return /* @__PURE__ */ jsx3(Alert, { type: "info", dismissible: false, children: /* @__PURE__ */ jsxs2(SpaceBetween3, { direction: "horizontal", size: "xs", alignItems: "center", children: [
    /* @__PURE__ */ jsx3(Spinner, {}),
    /* @__PURE__ */ jsx3("span", { children: message })
  ] }) });
};

// src/assets/agent-mode-icon.svg
var agent_mode_icon_default = 'data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 9.375C0.00273 11.8606 0.99133 14.2435 2.74889 16.0011C4.50645 17.7587 6.88943 18.7473 9.375 18.75H17.2809C17.6704 18.7495 18.0438 18.5946 18.3192 18.3192C18.5946 18.0438 18.7495 17.6704 18.75 17.2809V9.375C18.75 6.8886 17.7623 4.50403 16.0041 2.74587C14.246 0.98772 11.8614 0 9.375 0C6.8886 0 4.50403 0.98772 2.74587 2.74587C0.98772 4.50403 0 6.8886 0 9.375Z" fill="url(%23homeAgentIconGrad)"></path><path d="M9.3346 4.58203C9.1635 4.58203 9.0098 4.68665 8.947 4.84583L7.8349 7.66564L5.0151 8.77778C4.85592 8.84054 4.7513 8.99429 4.7513 9.16539C4.7513 9.33649 4.85592 9.49024 5.0151 9.55299L7.8349 10.6651L8.947 13.4849C9.0098 13.6441 9.1635 13.7487 9.3346 13.7487C9.5057 13.7487 9.6595 13.6441 9.7222 13.4849L10.8344 10.6651L13.6542 9.55299C13.8134 9.49024 13.918 9.33649 13.918 9.16539C13.918 8.99429 13.8134 8.84054 13.6542 8.77778L10.8344 7.66564L9.7222 4.84583C9.6595 4.68665 9.5057 4.58203 9.3346 4.58203Z" fill="white"></path><defs><radialGradient id="homeAgentIconGrad" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(20.4235 -1.67354) rotate(134.492) scale(39.845 50.9814)"><stop stop-color="%238376FE"></stop><stop offset="0.21" stop-color="%235C7FFF"></stop><stop offset="0.4" stop-color="%238575FF"></stop><stop offset="0.68" stop-color="%23962EFF"></stop></radialGradient></defs></svg>%0A';

// src/PromptInput/PromptInput.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var CloudscapePromptInput = PromptInputComponent;
var PromptInput = React.forwardRef(
  ({ lines = 1, placeholderText, onSubmit, isDisabled, loading, promptInputAction, logger, isRedesignEnabled = false, isEmbedded = false }, ref) => {
    const { t } = useAppTranslation3();
    const maxLength = 4e3;
    const { areFilesDragging } = useFilesDragging();
    const [value, setValue] = React.useState("");
    const [disclaimerVisible, setDisclaimerVisible] = React.useState(false);
    const [files, setFiles] = React.useState([]);
    const [uploadProgress, setUploadProgress] = React.useState({});
    const [uploadErrors, setUploadErrors] = React.useState({});
    const [isProcessing, setIsProcessing] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [templateVisibility, setTemplateVisibility] = React.useState(void 0);
    const internalRef = React.useRef(null);
    const inputRef = ref || internalRef;
    const prevDisabledRef = React.useRef(isDisabled);
    const disableSend = !value.trim() && files.length === 0 || value.length > maxLength;
    const handleFileChange = React.useCallback(
      (newFiles) => {
        const validFiles = [];
        const errors = {};
        newFiles.forEach((file) => {
          const validation = validateFiles([file]);
          if (!validation.isValid) {
            errors[file.name] = validation.errors.join(". ");
          } else {
            validFiles.push(file);
          }
        });
        if (validFiles.length > 0) {
          setFiles((prev) => [...prev, ...validFiles]);
        }
        if (Object.keys(errors).length > 0) {
          const invalidFiles = newFiles.filter((f) => errors[f.name]);
          setFiles((prev) => [...prev, ...invalidFiles]);
          setUploadErrors((prev) => ({ ...prev, ...errors }));
        }
      },
      [setFiles, setUploadErrors]
    );
    React.useEffect(() => {
      if (prevDisabledRef.current === true && isDisabled === false) {
        inputRef.current?.focus();
      }
      prevDisabledRef.current = isDisabled;
    }, [isDisabled, inputRef]);
    React.useEffect(() => {
      const action = promptInputAction?.action;
      const consume = promptInputAction?.consume;
      if (action && inputRef.current) {
        if (action.type === "insert-text") {
          setValue(action.text);
          if (action.visibility) {
            setTemplateVisibility(action.visibility);
          }
          setTimeout(() => {
            if (inputRef.current && action.selectionStart !== void 0 && action.selectionEnd !== void 0) {
              inputRef.current.setSelectionRange(action.selectionStart, action.selectionEnd);
            }
            inputRef.current?.focus();
          }, 0);
        }
        consume?.();
      }
    }, [promptInputAction, inputRef]);
    const handleSubmit = React.useCallback(() => {
      try {
        setError(null);
        console.log("Logger", logger);
        logger?.biMetric({
          metricName: "Click",
          value: 1,
          unit: "Count",
          dimensions: {
            ClickSelect: "send-message-button"
          }
        });
        if (disableSend) {
          return;
        }
        const hadFilesToUpload = files.length > 0;
        const uploadedFileNames = files.map((f) => f.name);
        let messageContent = value.trim();
        if (!messageContent && hadFilesToUpload) {
          messageContent = t("analyzeUploadedFiles", {
            plural: uploadedFileNames.length > 1 ? "s" : "",
            files: uploadedFileNames.join(", ")
          });
        }
        const contentBlocks = [];
        if (messageContent) {
          const isAutoGenerated = !value.trim() && hadFilesToUpload;
          contentBlocks.push({
            text: value.trim() || messageContent,
            visibility: templateVisibility ?? (isAutoGenerated ? ContentBlockVisibility.INFERENCE_ONLY : void 0)
          });
        }
        const uploadCallbacks = {
          onProgress: (fileName, percent) => {
            setUploadProgress((prev) => ({ ...prev, [fileName]: percent }));
          },
          onSuccess: (fileName) => {
            setUploadProgress((prev) => ({ ...prev, [fileName]: 100 }));
            setFiles((prev) => prev.filter((f) => f.name !== fileName));
          },
          onError: (fileName, errorMsg) => {
            setUploadErrors((prev) => ({ ...prev, [fileName]: errorMsg }));
          },
          onProcessing: () => {
            setIsProcessing(true);
          },
          onComplete: () => {
            setIsProcessing(false);
          }
        };
        onSubmit({
          contentBlocks,
          files,
          uploadCallbacks
        });
        setValue("");
        setTemplateVisibility(void 0);
      } catch (err) {
        setError(err instanceof Error ? err.message : t("failedToSendMessage"));
      }
    }, [onSubmit, files, value, disableSend, templateVisibility, logger, t]);
    const getStatusMessage = () => {
      const uploadingFiles = Object.keys(uploadProgress).filter((fileName) => uploadProgress[fileName] < 100);
      const errorFiles = Object.keys(uploadErrors);
      if (errorFiles.length > 0) {
        return {
          type: "error",
          message: t("failedToUploadFiles", {
            count: errorFiles.length,
            plural: errorFiles.length > 1 ? "s" : ""
          })
        };
      }
      if (isProcessing) {
        return {
          type: "updating",
          message: t("scanningFiles")
        };
      }
      if (uploadingFiles.length > 0) {
        return {
          type: "updating",
          message: t("uploadingFiles")
        };
      }
      return null;
    };
    const statusMessage = getStatusMessage();
    const spinnerPriority = React.useMemo(() => {
      if (statusMessage && statusMessage.type === "updating") {
        return "file-upload";
      }
      if (loading) {
        return "send-message";
      }
      return null;
    }, [statusMessage, loading]);
    const isUploading = Object.values(uploadProgress).some((progress) => progress < 100);
    return /* @__PURE__ */ jsxs3(SpaceBetween4, { size: "s", children: [
      error && /* @__PURE__ */ jsx4(StatusMessage, { type: "error", message: error, onDismiss: () => setError(null) }),
      /* @__PURE__ */ jsx4(
        FormField,
        {
          stretch: true,
          className: PromptInput_module_default.FormFieldPadding,
          "data-testid": "standard-layout-form-field",
          constraintText: /* @__PURE__ */ jsxs3("div", { className: PromptInput_module_default.FooterContainer, "data-testid": "standard-layout-footer", children: [
            !isRedesignEnabled && /* @__PURE__ */ jsx4("span", { "data-testid": "standard-layout-disclaimer", children: /* @__PURE__ */ jsxs3(AppTrans3, { i18nKey: "promptAgreeToDisclaimer", children: [
              /* @__PURE__ */ jsx4(Link2, { variant: "primary", onFollow: () => setDisclaimerVisible(true), "data-testid": "standard-layout-disclaimer-link" }),
              /* @__PURE__ */ jsx4("br", {})
            ] }) }),
            " ",
            /* @__PURE__ */ jsx4("span", { "data-testid": "standard-layout-character-count", children: t(isRedesignEnabled ? "characterCountCompact" : "characterCount", { current: value.length, max: maxLength }) })
          ] }),
          errorText: value.length > maxLength && t("promptTooManyCharacters"),
          children: /* @__PURE__ */ jsx4(
            CloudscapePromptInput,
            {
              ref: inputRef,
              "data-testid": "standard-layout-prompt-input",
              onChange: ({ detail }) => setValue(detail.value),
              disabled: isDisabled || isUploading || isProcessing || loading,
              disableActionButton: disableSend || loading,
              onAction: handleSubmit,
              value,
              actionButtonAriaLabel: loading ? t("sending") : t("sendMessage"),
              actionButtonIconName: loading ? void 0 : "send",
              actionButtonIconSvg: spinnerPriority === "send-message" ? /* @__PURE__ */ jsx4(Spinner2, { size: "normal", "data-testid": "action-button-spinner" }) : void 0,
              placeholder: placeholderText,
              minRows: lines,
              disableSecondaryActionsPaddings: true,
              secondaryActions: /* @__PURE__ */ jsxs3("div", { className: PromptInput_module_default.SecondaryActionsContainer, "data-testid": "standard-layout-secondary-actions", children: [
                /* @__PURE__ */ jsx4(
                  "div",
                  {
                    className: isRedesignEnabled && (isDisabled || isUploading || isProcessing || loading) ? PromptInput_module_default.FileInputDisabledWrapper : void 0,
                    children: /* @__PURE__ */ jsx4(
                      FileInput,
                      {
                        className: isRedesignEnabled ? PromptInput_module_default.RedesignDropzone : void 0,
                        variant: isRedesignEnabled ? "button" : "icon",
                        ariaLabel: isRedesignEnabled ? void 0 : t("uploadFiles"),
                        multiple: true,
                        value: files,
                        accept: ACCEPTED_EXTENSIONS_STRING,
                        onChange: ({ detail }) => {
                          detail.value.forEach((file) => {
                            logger?.biMetric({
                              metricName: "Click",
                              value: 1,
                              unit: "Count",
                              dimensions: {
                                ClickSelect: "file-upload-button",
                                ClickAct: `${file.size}`
                              }
                            });
                          });
                          handleFileChange(detail.value);
                        },
                        "data-testid": "standard-layout-file-input",
                        children: isRedesignEnabled ? t("dropRequirementsOrRfps") : void 0
                      }
                    )
                  }
                ),
                statusMessage && /* @__PURE__ */ jsxs3("div", { className: PromptInput_module_default.StatusContainer, children: [
                  spinnerPriority === "file-upload" && /* @__PURE__ */ jsx4(Spinner2, { size: "normal" }),
                  /* @__PURE__ */ jsx4("span", { className: statusMessage.type === "error" ? PromptInput_module_default.StatusTextError : PromptInput_module_default.StatusText, children: statusMessage.message })
                ] })
              ] }),
              secondaryContent: isEmbedded || files.length > 0 || areFilesDragging ? /* @__PURE__ */ jsx4("div", { className: isEmbedded ? PromptInput_module_default.SecondaryContentWrapper : void 0, children: /* @__PURE__ */ jsxs3(SpaceBetween4, { size: "xs", children: [
                isEmbedded && /* @__PURE__ */ jsxs3("div", { className: PromptInput_module_default.AskAgentModeLabel, "data-testid": "ask-agent-mode-label", children: [
                  /* @__PURE__ */ jsx4(Icon, { url: agent_mode_icon_default, alt: "" }),
                  /* @__PURE__ */ jsx4("span", { children: t("askAgentMode") })
                ] }),
                areFilesDragging ? /* @__PURE__ */ jsx4(FileDropzone, { onChange: ({ detail }) => handleFileChange(detail.value), "data-testid": "standard-layout-file-dropzone", children: /* @__PURE__ */ jsxs3(SpaceBetween4, { size: "xs", alignItems: "center", children: [
                  /* @__PURE__ */ jsx4(Icon, { name: "upload", "data-testid": "standard-layout-upload-icon" }),
                  /* @__PURE__ */ jsx4(Box3, { "data-testid": "standard-layout-drop-text", children: t("dropFilesHere") })
                ] }) }) : files.length > 0 ? /* @__PURE__ */ jsx4(
                  FileTokenGroup,
                  {
                    "data-testid": "standard-layout-file-tokens",
                    items: files.map((file) => {
                      const progress = uploadProgress[file.name];
                      const error2 = uploadErrors[file.name];
                      return {
                        file,
                        loading: progress !== void 0 && progress < 100,
                        errorText: error2
                      };
                    }),
                    onDismiss: ({ detail }) => {
                      const removedFile = files[detail.fileIndex];
                      setFiles((files2) => files2.filter((_, index) => index !== detail.fileIndex));
                      setUploadErrors((prev) => {
                        const newErrors = { ...prev };
                        delete newErrors[removedFile.name];
                        return newErrors;
                      });
                    },
                    alignment: "horizontal",
                    showFileSize: true,
                    showFileLastModified: true,
                    showFileThumbnail: true,
                    i18nStrings: {
                      removeFileAriaLabel: () => t("removeFile"),
                      limitShowFewer: t("showFewerFiles"),
                      limitShowMore: t("showMoreFiles"),
                      errorIconAriaLabel: t("errorIconAriaLabel"),
                      warningIconAriaLabel: t("warningIconAriaLabel")
                    }
                  }
                ) : null
              ] }) }) : void 0
            }
          )
        }
      ),
      !isRedesignEnabled && /* @__PURE__ */ jsx4(AwsTermsDisclaimerModal, { visible: disclaimerVisible, onDismiss: () => setDisclaimerVisible(false) })
    ] });
  }
);
PromptInput.displayName = "PromptInput";

// src/NewProjectSection/NewProjectSection.module.scss
var NewProjectSection_module_default = {
  disclaimerFooterEmbedded: "NewProjectSection_module_disclaimerFooterEmbedded",
  taskCardsContainer: "NewProjectSection_module_taskCardsContainer",
  taskCard: "NewProjectSection_module_taskCard",
  taskCardContent: "NewProjectSection_module_taskCardContent",
  taskIcon: "NewProjectSection_module_taskIcon",
  taskTextContent: "NewProjectSection_module_taskTextContent",
  taskTitle: "NewProjectSection_module_taskTitle",
  taskDescription: "NewProjectSection_module_taskDescription",
  actionCardsContainer: "NewProjectSection_module_actionCardsContainer",
  disclaimerFooter: "NewProjectSection_module_disclaimerFooter",
  disclaimerLink: "NewProjectSection_module_disclaimerLink",
  actionCardButton: "NewProjectSection_module_actionCardButton",
  actionCardContent: "NewProjectSection_module_actionCardContent",
  actionCardTextWrapper: "NewProjectSection_module_actionCardTextWrapper",
  actionCardNewBadge: "NewProjectSection_module_actionCardNewBadge",
  actionCardArrow: "NewProjectSection_module_actionCardArrow"
};

// src/NewProjectSection/compare-products-icon.svg
var compare_products_icon_default = 'data:image/svg+xml,<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<rect width="28" height="28" rx="4" fill="url(%23paint0_radial_3506_157158)"/>%0A<path d="M17.643 10.3571C17.4352 9.23764 16.9255 8.19624 16.169 7.34533C15.4125 6.49442 14.4379 5.86633 13.3505 5.52887C12.263 5.19141 11.1041 5.15741 9.99878 5.43054C8.89345 5.70366 7.88372 6.27354 7.07863 7.07863C6.27354 7.88372 5.70366 8.89345 5.43054 9.99878C5.15741 11.1041 5.19141 12.263 5.52887 13.3505C5.86633 14.4379 6.49442 15.4125 7.34533 16.169C8.19624 16.9255 9.23764 17.4352 10.3571 17.643C10.5649 18.7625 11.0746 19.8039 11.8311 20.6548C12.5876 21.5057 13.5622 22.1338 14.6496 22.4712C15.7371 22.8087 16.896 22.8427 18.0013 22.5696C19.1067 22.2964 20.1164 21.7266 20.9215 20.9215C21.7266 20.1164 22.2964 19.1067 22.5696 18.0013C22.8427 16.896 22.8087 15.7371 22.4712 14.6496C22.1338 13.5622 21.5057 12.5876 20.6548 11.8311C19.8039 11.0746 18.7625 10.5649 17.643 10.3571ZM11.8665 14.6251L13.3751 16.1336C12.7797 16.3761 12.1429 16.5006 11.5001 16.5001C11.4995 15.8572 11.624 15.2204 11.8665 14.6251ZM14.5032 15.4946L12.5055 13.4969C12.7883 13.122 13.122 12.7883 13.4969 12.5055L15.4946 14.5032C15.2118 14.8781 14.8781 15.2118 14.5032 15.4946ZM16.1336 13.3751L14.6251 11.8665C15.2204 11.624 15.8572 11.4995 16.5001 11.5001C16.5006 12.1429 16.3761 12.7797 16.1336 13.3751ZM6.50005 11.5001C6.49765 10.2814 6.94043 9.10376 7.74517 8.18855C8.54991 7.27335 9.6612 6.68356 10.8702 6.53004C12.0792 6.37652 13.3026 6.66983 14.3105 7.35486C15.3185 8.03988 16.0415 9.06944 16.3438 10.2501C14.7413 10.2922 13.2161 10.9478 12.0829 12.0817C10.9497 13.2156 10.295 14.7413 10.254 16.3438C9.18027 16.066 8.22915 15.4396 7.54978 14.563C6.8704 13.6864 6.50119 12.6091 6.50005 11.5001ZM16.5001 21.5C15.3915 21.4991 14.3146 21.1305 13.4381 20.4519C12.5615 19.7733 11.9349 18.823 11.6563 17.7501C13.2595 17.7089 14.7857 17.0537 15.9197 15.9197C17.0537 14.7857 17.7089 13.2595 17.7501 11.6563C18.9307 11.9586 19.9602 12.6816 20.6452 13.6896C21.3303 14.6975 21.6236 15.9209 21.4701 17.1299C21.3165 18.3389 20.7268 19.4502 19.8115 20.2549C18.8963 21.0597 17.7187 21.5024 16.5001 21.5Z" fill="white"/>%0A<defs>%0A<radialGradient id="paint0_radial_3506_157158" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(30.4992 -2.49915) rotate(135) scale(46.6667 59.7097)">%0A<stop stop-color="%23B8E7FF"/>%0A<stop offset="0.3" stop-color="%230099FF"/>%0A<stop offset="0.45" stop-color="%235C7FFF"/>%0A<stop offset="0.6" stop-color="%238575FF"/>%0A<stop offset="0.8" stop-color="%23962EFF"/>%0A</radialGradient>%0A</defs>%0A</svg>%0A';

// src/NewProjectSection/create-proposal-icon.svg
var create_proposal_icon_default = 'data:image/svg+xml,<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<rect width="28" height="28" rx="4" fill="url(%23paint0_radial_3506_157171)"/>%0A<path d="M20.6922 10.4328L16.3172 6.05781C16.2591 5.99979 16.1902 5.95378 16.1143 5.92241C16.0384 5.89105 15.9571 5.87494 15.875 5.875H8.375C8.04348 5.875 7.72554 6.0067 7.49112 6.24112C7.2567 6.47554 7.125 6.79348 7.125 7.125V20.875C7.125 21.2065 7.2567 21.5245 7.49112 21.7589C7.72554 21.9933 8.04348 22.125 8.375 22.125H19.625C19.9565 22.125 20.2745 21.9933 20.5089 21.7589C20.7433 21.5245 20.875 21.2065 20.875 20.875V10.875C20.8751 10.7929 20.859 10.7116 20.8276 10.6357C20.7962 10.5598 20.7502 10.4909 20.6922 10.4328ZM16.5 8.00859L18.7414 10.25H16.5V8.00859ZM19.625 20.875H8.375V7.125H15.25V10.875C15.25 11.0408 15.3158 11.1997 15.4331 11.3169C15.5503 11.4342 15.7092 11.5 15.875 11.5H19.625V20.875ZM16.5 15.875C16.5 16.0408 16.4342 16.1997 16.3169 16.3169C16.1997 16.4342 16.0408 16.5 15.875 16.5H14.625V17.75C14.625 17.9158 14.5592 18.0747 14.4419 18.1919C14.3247 18.3092 14.1658 18.375 14 18.375C13.8342 18.375 13.6753 18.3092 13.5581 18.1919C13.4408 18.0747 13.375 17.9158 13.375 17.75V16.5H12.125C11.9592 16.5 11.8003 16.4342 11.6831 16.3169C11.5658 16.1997 11.5 16.0408 11.5 15.875C11.5 15.7092 11.5658 15.5503 11.6831 15.4331C11.8003 15.3158 11.9592 15.25 12.125 15.25H13.375V14C13.375 13.8342 13.4408 13.6753 13.5581 13.5581C13.6753 13.4408 13.8342 13.375 14 13.375C14.1658 13.375 14.3247 13.4408 14.4419 13.5581C14.5592 13.6753 14.625 13.8342 14.625 14V15.25H15.875C16.0408 15.25 16.1997 15.3158 16.3169 15.4331C16.4342 15.5503 16.5 15.7092 16.5 15.875Z" fill="white"/>%0A<defs>%0A<radialGradient id="paint0_radial_3506_157171" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(30.4992 -2.49915) rotate(135) scale(46.6667 59.7097)">%0A<stop stop-color="%23B8E7FF"/>%0A<stop offset="0.3" stop-color="%230099FF"/>%0A<stop offset="0.45" stop-color="%235C7FFF"/>%0A<stop offset="0.6" stop-color="%238575FF"/>%0A<stop offset="0.8" stop-color="%23962EFF"/>%0A</radialGradient>%0A</defs>%0A</svg>%0A';

// src/NewProjectSection/deploy-icon.svg
var deploy_icon_default = 'data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M8.10666 14.5256C8.07619 14.6467 7.31447 17.499 3.12463 17.499C2.95887 17.499 2.79989 17.4332 2.68268 17.316C2.56547 17.1988 2.49963 17.0398 2.49963 16.874C2.49963 12.6842 5.35197 11.9225 5.47306 11.892C5.63395 11.8518 5.80422 11.8772 5.94641 11.9625C6.08861 12.0478 6.19107 12.1862 6.23127 12.3471C6.27146 12.508 6.2461 12.6782 6.16076 12.8204C6.07541 12.9626 5.93708 13.0651 5.77619 13.1053C5.70588 13.1248 4.02463 13.6162 3.77931 16.2193C6.38244 15.974 6.87463 14.2959 6.89494 14.2178C6.93638 14.0571 7.03995 13.9194 7.18288 13.8351C7.3258 13.7508 7.49636 13.7267 7.65705 13.7682C7.81773 13.8096 7.95537 13.9132 8.03969 14.0561C8.12401 14.199 8.1481 14.3696 8.10666 14.5303V14.5256ZM15.3723 9.25996L14.9996 9.63261V14.1896C15.0006 14.3544 14.9687 14.5177 14.9059 14.6701C14.8432 14.8225 14.7507 14.9608 14.634 15.0771L11.9528 17.7568C11.8371 17.8733 11.6996 17.9657 11.5481 18.0287C11.3965 18.0917 11.234 18.1241 11.0699 18.124C10.9345 18.124 10.8 18.1021 10.6715 18.0592C10.4509 17.9862 10.2552 17.853 10.1064 17.6747C9.95754 17.4963 9.86157 17.2799 9.82931 17.0498L9.40978 14.0428L5.95588 10.5889L2.95041 10.1693C2.72005 10.137 2.50328 10.0411 2.32447 9.89229C2.14567 9.7435 2.01193 9.54777 1.9383 9.32712C1.86467 9.10647 1.85407 8.86965 1.90769 8.64331C1.96131 8.41696 2.07702 8.21006 2.24181 8.04589L4.9215 5.36464C5.03781 5.24791 5.17617 5.15547 5.32853 5.09271C5.4809 5.02994 5.64422 4.99809 5.809 4.99902H10.366L10.7387 4.62636C12.8231 2.54277 15.3348 2.45293 16.3176 2.51152C16.6223 2.53004 16.9098 2.65945 17.1257 2.87533C17.3415 3.09122 17.4709 3.37865 17.4895 3.68339C17.5465 4.66386 17.4567 7.17558 15.3731 9.25996H15.3723ZM3.12463 8.93183L6.02697 9.33652L9.11603 6.24902H5.809L3.12463 8.93183ZM7.134 9.99902L9.99963 12.8646L14.4879 8.37636C15.0928 7.77558 15.562 7.05228 15.8641 6.25509C16.1663 5.45789 16.2942 4.60525 16.2395 3.75449C15.3892 3.70176 14.5374 3.83107 13.741 4.1338C12.9447 4.43652 12.2221 4.90569 11.6215 5.50996L7.134 9.99902ZM13.7496 10.8826L10.6613 13.9709L11.0676 16.874L13.7496 14.1896V10.8826Z" fill="url(%23paint0_radial_deploy)"/>%0A<defs>%0A<radialGradient id="paint0_radial_deploy" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(-18.416 18.4131 -23.5631 -23.5594 18.8953 1.10547)">%0A<stop stop-color="%23B8E7FF"/>%0A<stop offset="0.3" stop-color="%230099FF"/>%0A<stop offset="0.45" stop-color="%235C7FFF"/>%0A<stop offset="0.6" stop-color="%238575FF"/>%0A<stop offset="0.8" stop-color="%23962EFF"/>%0A</radialGradient>%0A</defs>%0A</svg>%0A';

// src/NewProjectSection/buy-icon.svg
var buy_icon_default = 'data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M5.625 8.125C5.625 7.95924 5.69085 7.80027 5.80806 7.68306C5.92527 7.56585 6.08424 7.5 6.25 7.5H13.75C13.9158 7.5 14.0747 7.56585 14.1919 7.68306C14.3092 7.80027 14.375 7.95924 14.375 8.125C14.375 8.29076 14.3092 8.44973 14.1919 8.56694C14.0747 8.68415 13.9158 8.75 13.75 8.75H6.25C6.08424 8.75 5.92527 8.68415 5.80806 8.56694C5.69085 8.44973 5.625 8.29076 5.625 8.125ZM6.25 11.25H13.75C13.9158 11.25 14.0747 11.1842 14.1919 11.0669C14.3092 10.9497 14.375 10.7908 14.375 10.625C14.375 10.4592 14.3092 10.3003 14.1919 10.1831C14.0747 10.0658 13.9158 10 13.75 10H6.25C6.08424 10 5.92527 10.0658 5.80806 10.1831C5.69085 10.3003 5.625 10.4592 5.625 10.625C5.625 10.7908 5.69085 10.9497 5.80806 11.0669C5.92527 11.1842 6.08424 11.25 6.25 11.25ZM18.125 4.375V16.25C18.1249 16.3565 18.0977 16.4613 18.0457 16.5543C17.9938 16.6473 17.919 16.7255 17.8284 16.7815C17.7377 16.8374 17.6343 16.8693 17.5279 16.874C17.4214 16.8788 17.3156 16.8563 17.2203 16.8086L15 15.6984L12.7797 16.8086C12.6929 16.852 12.5971 16.8747 12.5 16.8747C12.4029 16.8747 12.3071 16.852 12.2203 16.8086L10 15.6984L7.77969 16.8086C7.69286 16.852 7.5971 16.8747 7.5 16.8747C7.4029 16.8747 7.30714 16.852 7.22031 16.8086L5 15.6984L2.77969 16.8086C2.68442 16.8563 2.57856 16.8788 2.47214 16.874C2.36572 16.8693 2.26228 16.8374 2.17165 16.7815C2.08101 16.7255 2.00618 16.6473 1.95426 16.5543C1.90234 16.4613 1.87506 16.3565 1.875 16.25V4.375C1.875 4.04348 2.0067 3.72554 2.24112 3.49112C2.47554 3.2567 2.79348 3.125 3.125 3.125H16.875C17.2065 3.125 17.5245 3.2567 17.7589 3.49112C17.9933 3.72554 18.125 4.04348 18.125 4.375ZM16.875 4.375H3.125V15.2391L4.72031 14.4406C4.80714 14.3972 4.9029 14.3746 5 14.3746C5.0971 14.3746 5.19286 14.3972 5.27969 14.4406L7.5 15.5516L9.72031 14.4406C9.80714 14.3972 9.9029 14.3746 10 14.3746C10.0971 14.3746 10.1929 14.3972 10.2797 14.4406L12.5 15.5516L14.7203 14.4406C14.8071 14.3972 14.9029 14.3746 15 14.3746C15.0971 14.3746 15.1929 14.3972 15.2797 14.4406L16.875 15.2391V4.375Z" fill="url(%23paint0_radial_buy)"/>%0A<defs>%0A<radialGradient id="paint0_radial_buy" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(-19.1508 16.2041 -24.5033 -20.7331 19.5754 1.89777)">%0A<stop stop-color="%23B8E7FF"/>%0A<stop offset="0.3" stop-color="%230099FF"/>%0A<stop offset="0.45" stop-color="%235C7FFF"/>%0A<stop offset="0.6" stop-color="%238575FF"/>%0A<stop offset="0.8" stop-color="%23962EFF"/>%0A</radialGradient>%0A</defs>%0A</svg>%0A';

// src/NewProjectSection/compare-products-icon-redesign.svg
var compare_products_icon_redesign_default = 'data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M13.643 6.35904C13.4352 5.23959 12.9255 4.1982 12.169 3.34729C11.4125 2.49638 10.4379 1.86828 9.35046 1.53083C8.26305 1.19337 7.10411 1.15936 5.99878 1.43249C4.89345 1.70561 3.88372 2.27549 3.07863 3.08058C2.27354 3.88568 1.70366 4.8954 1.43054 6.00073C1.15741 7.10606 1.19141 8.265 1.52887 9.35242C1.86633 10.4398 2.49442 11.4144 3.34533 12.1709C4.19624 12.9274 5.23764 13.4371 6.35708 13.645C6.56493 14.7644 7.07463 15.8058 7.83114 16.6567C8.58765 17.5076 9.56222 18.1357 10.6496 18.4732C11.7371 18.8106 12.896 18.8446 14.0013 18.5715C15.1067 18.2984 16.1164 17.7285 16.9215 16.9234C17.7266 16.1183 18.2964 15.1086 18.5696 14.0033C18.8427 12.8979 18.8087 11.739 18.4712 10.6516C18.1338 9.56417 17.5057 8.5896 16.6548 7.83309C15.8039 7.07658 14.7625 6.56689 13.643 6.35904ZM7.86646 10.627L9.37505 12.1356C8.77971 12.3781 8.14289 12.5025 7.50005 12.502C7.49951 11.8592 7.62396 11.2224 7.86646 10.627ZM10.5032 11.4965L8.50552 9.49888C8.78829 9.12393 9.12197 8.79024 9.49693 8.50747L11.4946 10.5051C11.2118 10.8801 10.8781 11.2138 10.5032 11.4965ZM12.1336 9.377L10.6251 7.86841C11.2204 7.62591 11.8572 7.50147 12.5001 7.502C12.5006 8.14484 12.3761 8.78166 12.1336 9.377ZM2.50005 7.502C2.49765 6.28332 2.94043 5.10571 3.74517 4.19051C4.54991 3.2753 5.6612 2.68552 6.87018 2.53199C8.07916 2.37847 9.30259 2.67179 10.3105 3.35681C11.3185 4.04183 12.0415 5.0714 12.3438 6.252C10.7413 6.29412 9.21608 6.94977 8.0829 8.08368C6.94972 9.21758 6.29504 10.7432 6.25396 12.3458C5.18027 12.0679 4.22915 11.4416 3.54978 10.565C2.8704 9.68837 2.50119 8.61106 2.50005 7.502ZM12.5001 17.502C11.3915 17.5011 10.3146 17.1324 9.43806 16.4538C8.56151 15.7752 7.93486 14.825 7.6563 13.752C9.2595 13.7109 10.7857 13.0557 11.9197 11.9216C13.0537 10.7876 13.7089 9.26145 13.7501 7.65825C14.9307 7.96053 15.9602 8.68358 16.6452 9.69152C17.3303 10.6995 17.6236 11.9229 17.4701 13.1319C17.3165 14.3409 16.7268 15.4521 15.8115 16.2569C14.8963 17.0616 13.7187 17.5044 12.5001 17.502Z" fill="url(%23paint0_radial_compare)"/>%0A<defs>%0A<radialGradient id="paint0_radial_compare" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(20.3144 -0.312328) rotate(135) scale(29.1733 37.3271)">%0A<stop stop-color="%23B8E7FF"/>%0A<stop offset="0.3" stop-color="%230099FF"/>%0A<stop offset="0.45" stop-color="%235C7FFF"/>%0A<stop offset="0.6" stop-color="%238575FF"/>%0A<stop offset="0.8" stop-color="%23962EFF"/>%0A</radialGradient>%0A</defs>%0A</svg>%0A';

// src/NewProjectSection/create-proposal-icon-redesign.svg
var create_proposal_icon_redesign_default = 'data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M16.6922 6.43281L12.3172 2.05781C12.2591 1.99979 12.1902 1.95378 12.1143 1.92241C12.0384 1.89105 11.9571 1.87494 11.875 1.875H4.375C4.04348 1.875 3.72554 2.0067 3.49112 2.24112C3.2567 2.47554 3.125 2.79348 3.125 3.125V16.875C3.125 17.2065 3.2567 17.5245 3.49112 17.7589C3.72554 17.9933 4.04348 18.125 4.375 18.125H15.625C15.9565 18.125 16.2745 17.9933 16.5089 17.7589C16.7433 17.5245 16.875 17.2065 16.875 16.875V6.875C16.8751 6.7929 16.859 6.71159 16.8276 6.63572C16.7962 6.55985 16.7502 6.4909 16.6922 6.43281ZM12.5 4.00859L14.7414 6.25H12.5V4.00859ZM15.625 16.875H4.375V3.125H11.25V6.875C11.25 7.04076 11.3158 7.19973 11.4331 7.31694C11.5503 7.43415 11.7092 7.5 11.875 7.5H15.625V16.875ZM12.5 11.875C12.5 12.0408 12.4342 12.1997 12.3169 12.3169C12.1997 12.4342 12.0408 12.5 11.875 12.5H10.625V13.75C10.625 13.9158 10.5592 14.0747 10.4419 14.1919C10.3247 14.3092 10.1658 14.375 10 14.375C9.83424 14.375 9.67527 14.3092 9.55806 14.1919C9.44085 14.0747 9.375 13.9158 9.375 13.75V12.5H8.125C7.95924 12.5 7.80027 12.4342 7.68306 12.3169C7.56585 12.1997 7.5 12.0408 7.5 11.875C7.5 11.7092 7.56585 11.5503 7.68306 11.4331C7.80027 11.3158 7.95924 11.25 8.125 11.25H9.375V10C9.375 9.83424 9.44085 9.67527 9.55806 9.55806C9.67527 9.44085 9.83424 9.375 10 9.375C10.1658 9.375 10.3247 9.44085 10.4419 9.55806C10.5592 9.67527 10.625 9.83424 10.625 10V11.25H11.875C12.0408 11.25 12.1997 11.3158 12.3169 11.4331C12.4342 11.5503 12.5 11.7092 12.5 11.875Z" fill="url(%23paint0_radial_proposal)"/>%0A<defs>%0A<radialGradient id="paint0_radial_proposal" cx="0" cy="0" r="1" gradientTransform="matrix(-16.2045 19.1508 -20.7336 -24.5033 18.1023 0.424599)" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%23B8E7FF"/>%0A<stop offset="0.3" stop-color="%230099FF"/>%0A<stop offset="0.45" stop-color="%235C7FFF"/>%0A<stop offset="0.6" stop-color="%238575FF"/>%0A<stop offset="0.8" stop-color="%23962EFF"/>%0A</radialGradient>%0A</defs>%0A</svg>%0A';

// src/NewProjectSection/NewProjectSection.tsx
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var NewProjectSection = ({
  projectCreation,
  navigation,
  logger,
  variant = "full",
  promptLines = 5,
  placeholderText,
  isRedesignEnabled = false
}) => {
  const { createProjectWithStreaming, error } = projectCreation;
  const { navigate } = navigation;
  const { t } = useAppTranslation4();
  const [loading, setLoading] = React2.useState(false);
  const [disclaimerVisible, setDisclaimerVisible] = React2.useState(false);
  React2.useEffect(() => {
    if (error) {
      setLoading(false);
    }
  }, [error]);
  const handleSubmit = React2.useCallback(
    ({ contentBlocks, files, uploadCallbacks }) => {
      const firstBlock = contentBlocks[0];
      const firstBlockText = firstBlock && "text" in firstBlock ? firstBlock.text : "";
      setLoading(true);
      const sanitizedText = firstBlockText.replace(/[\x00-\x1F\x7F]/g, " ").replace(/[\uD800-\uDFFF]/g, "").trim();
      const projectNameText = sanitizedText.slice(0, 50);
      createProjectWithStreaming({
        projectName: `Project: ${projectNameText}${sanitizedText.length > 50 ? "..." : ""}`,
        agent: { agentId: "none" },
        contentBlocks,
        files,
        uploadCallbacks
      });
    },
    [createProjectWithStreaming]
  );
  const showContainer = variant === "full";
  const showHeader = variant === "full";
  const actionCards = [
    {
      id: "compare-products",
      title: t("compare"),
      iconUrl: compare_products_icon_redesign_default,
      route: "compare"
    },
    {
      id: "create-proposal",
      title: t("createProposal"),
      iconUrl: create_proposal_icon_redesign_default,
      route: "proposal"
    },
    {
      id: "buy",
      title: t("buy"),
      iconUrl: buy_icon_default,
      isNew: true,
      route: "/",
      agentId: "checkout"
    },
    {
      id: "deploy",
      title: t("deploy"),
      iconUrl: deploy_icon_default,
      isNew: true,
      route: "/",
      agentId: "deployment"
    }
  ];
  const handleActionCardClick = (card) => {
    logger.biMetric({
      metricName: "Click",
      value: 1,
      unit: "Count",
      dimensions: {
        ClickSelect: `${card.id}-button`
      }
    });
    if (card.agentId) {
      window.location.href = `${window.location.origin}${window.location.pathname}?agent=${card.agentId}#${card.route}?agent=${card.agentId}`;
    } else {
      navigate(card.route);
    }
  };
  const redesignContent = /* @__PURE__ */ jsxs4("div", { className: NewProjectSection_module_default.redesignContent, "data-testid": "new-project-section", children: [
    showHeader && /* @__PURE__ */ jsx5(Header, { variant: "h2", children: t("newProject") }),
    /* @__PURE__ */ jsx5(Box4, { padding: { top: "s" }, children: /* @__PURE__ */ jsx5(
      PromptInput,
      {
        lines: promptLines,
        placeholderText: placeholderText || t("describeUseCasePlaceholder"),
        onSubmit: handleSubmit,
        loading,
        logger,
        isRedesignEnabled: true,
        isEmbedded: variant === "embedded"
      }
    ) }),
    /* @__PURE__ */ jsx5("div", { className: NewProjectSection_module_default.actionCardsContainer, "data-testid": "action-cards-container", children: actionCards.map((card) => /* @__PURE__ */ jsx5(
      "button",
      {
        type: "button",
        onClick: () => handleActionCardClick(card),
        "data-testid": `action-card-${card.id}`,
        className: NewProjectSection_module_default.actionCardButton,
        children: /* @__PURE__ */ jsxs4("span", { className: NewProjectSection_module_default.actionCardContent, children: [
          /* @__PURE__ */ jsx5(Icon2, { url: card.iconUrl, alt: "", size: "medium" }),
          /* @__PURE__ */ jsxs4("span", { className: NewProjectSection_module_default.actionCardTextWrapper, children: [
            /* @__PURE__ */ jsx5("span", { children: card.title }),
            card.isNew && /* @__PURE__ */ jsx5("span", { className: NewProjectSection_module_default.actionCardNewBadge, children: /* @__PURE__ */ jsxs4("em", { children: [
              " - ",
              t("new")
            ] }) })
          ] }),
          /* @__PURE__ */ jsx5("span", { className: NewProjectSection_module_default.actionCardArrow, children: /* @__PURE__ */ jsx5(Icon2, { name: "arrow-right", ariaLabel: "" }) })
        ] })
      },
      card.id
    )) }),
    /* @__PURE__ */ jsx5("div", { className: variant === "embedded" ? void 0 : NewProjectSection_module_default.disclaimerFooter, "data-testid": "disclaimer-footer", children: /* @__PURE__ */ jsx5(Box4, { color: "text-body-secondary", fontSize: "body-s", children: /* @__PURE__ */ jsx5("span", { className: variant === "embedded" ? NewProjectSection_module_default.disclaimerFooterEmbedded : void 0, children: /* @__PURE__ */ jsx5(AppTrans4, { i18nKey: "promptAgreeToDisclaimer", children: /* @__PURE__ */ jsx5(
      "button",
      {
        type: "button",
        className: NewProjectSection_module_default.disclaimerLink,
        onClick: () => {
          setDisclaimerVisible(true);
        },
        "data-testid": "disclaimer-link"
      }
    ) }) }) }) }),
    /* @__PURE__ */ jsx5(AwsTermsDisclaimerModal, { visible: disclaimerVisible, onDismiss: () => setDisclaimerVisible(false) })
  ] });
  const deepResearchLabel = /* @__PURE__ */ jsx5(Box4, { variant: "awsui-gen-ai-label", children: t("deepResearch") });
  const taskCards = [
    {
      title: t("compareProducts"),
      description: t("compareProductsDescription"),
      iconUrl: compare_products_icon_default,
      labelComponent: deepResearchLabel,
      onClick: () => {
        logger.biMetric({
          metricName: "Click",
          value: 1,
          unit: "Count",
          dimensions: {
            ClickSelect: "compare-products-button"
          }
        });
        navigate("compare");
      }
    },
    {
      title: t("createProposal"),
      description: t("createProposalDescription"),
      iconUrl: create_proposal_icon_default,
      labelComponent: deepResearchLabel,
      onClick: () => {
        logger.biMetric({
          metricName: "Click",
          value: 1,
          unit: "Count",
          dimensions: {
            ClickSelect: "create-proposal-button"
          }
        });
        navigate("proposal");
      }
    }
  ];
  const originalContent = /* @__PURE__ */ jsxs4(SpaceBetween5, { direction: "vertical", size: "s", children: [
    showHeader && /* @__PURE__ */ jsx5(Header, { variant: "h2", children: t("newProject") }),
    /* @__PURE__ */ jsx5(Box4, { padding: { top: "s" }, children: /* @__PURE__ */ jsx5(
      PromptInput,
      {
        lines: promptLines,
        placeholderText: placeholderText || t("tellUsAboutYourBusinessNeed"),
        onSubmit: handleSubmit,
        loading,
        logger
      }
    ) }),
    /* @__PURE__ */ jsx5(Box4, { padding: { top: "s" }, children: /* @__PURE__ */ jsxs4(SpaceBetween5, { direction: "vertical", size: "xs", children: [
      /* @__PURE__ */ jsx5(Header, { variant: "h3", children: t("tryTheseTasks") }),
      /* @__PURE__ */ jsx5("div", { className: NewProjectSection_module_default.taskCardsContainer, children: taskCards.map((card, index) => /* @__PURE__ */ jsx5("div", { className: NewProjectSection_module_default.taskCard, onClick: card.onClick, children: /* @__PURE__ */ jsxs4("div", { className: NewProjectSection_module_default.taskCardContent, children: [
        /* @__PURE__ */ jsx5("img", { src: card.iconUrl, alt: card.title, width: "28", height: "28", className: NewProjectSection_module_default.taskIcon }),
        /* @__PURE__ */ jsxs4("div", { className: NewProjectSection_module_default.taskTextContent, children: [
          /* @__PURE__ */ jsx5("div", { className: NewProjectSection_module_default.taskTitle, children: card.title }),
          /* @__PURE__ */ jsx5("div", { className: NewProjectSection_module_default.taskDescription, children: card.description })
        ] }),
        card.labelComponent
      ] }) }, index)) })
    ] }) })
  ] });
  if (isRedesignEnabled) {
    return showContainer ? /* @__PURE__ */ jsx5(Container, { "data-testid": "new-project-container", children: redesignContent }) : /* @__PURE__ */ jsx5("div", { "data-testid": "new-project-container", children: redesignContent });
  }
  return showContainer ? /* @__PURE__ */ jsx5(Container, { children: originalContent }) : originalContent;
};
export {
  NewProjectSection
};
//# sourceMappingURL=index.js.map
